<div id="advisor-wrapper" class="minicheck grid-container">
  @if (actionName) {
    <form [formGroup]="form" (submit)="calculateAction()">
      <app-advisor-image [path]="'/mic/' + category + '.svg'"></app-advisor-image>
      <div class="grid-x grid-margin-x">
        <div class="cell small-12  headline-wrapper">
          <h1 [innerHTML]="('minicheck.' + actionName + '.headline') | translate"></h1>
          <p [innerHTML]="('minicheck.' + actionName + '.text') | translate"></p>
        </div>
        @if (formError) {
          <div role="alert" class="cell form-errors">
            <p [innerHTML]="'minicheck.error.' + formError | translate: {fallback: 'formerror.error.' + formError}"></p>
          </div>
        }
        @for (field of formConfig.getFieldsFromGroup(actionName); track field.type) {
        <ng-container>
          <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineInfo" [form]="form"
               [formModel]="field" [formConfig]="formConfig" class="cell formfield {{field.type}} {{field.classes}}"
               [step]="'minicheck'"></div>
        </ng-container>
        }
      </div>
      <button type="submit" class="button primary inline-arrow-right" [class.disabled]="isButtonDisabled"
              [disabled]="isButtonDisabled" [innerHTML]="'minicheck.button.calculate' | translate"
              [attr.aria-expanded]="hasResult" aria-controls="result"></button>
    </form>
  }


  @if (hasResult) {
    <div id="result" class="grid-x grid-margin-x">
      <div class="cell">
        <h2 class="text-center" [innerHTML]="('minicheck' + (isInputNeeded ? '.input.needed' : showUpdatedResult ? '.updating' : isNegativeSavingEur ? '.negative.savings' : '') + '.result.headline') | translate"></h2>
        @if (showUpdatedResult) {
          <div class="loading"></div>
        }
        @if (isInputNeeded) {
          <i class="icon-help-circle"></i>
        }
        @if (!showUpdatedResult && !isInputNeeded) {
          <div class="savings text-center cell" [class.both-savings]="isPositiveSavingCo2 && isPositiveSavingEur">
            <div [class.co2-info]="isPositiveSavingCo2" [class.co2-negative-info]="isNegativeSavingCo2"
                 [class.hide]="isNegativeSavingEur || isNegativeSavingCo2">
              <i class="icon-co2"></i>
              <p class="co2-saving"
                 [innerHTML]="'minicheck.co2.saving' + (co2OneTon ? '.ton' : co2Tonnes ? '.tonnes' : '') | translate: placeholder"></p>
            </div>
            @if (result?.savingEur !== 0) {
              <div [class.money-info]="isPositiveSavingEur" [class.money-negative-info]="isNegativeSavingEur">
                <i class="icon-wallet-money"></i>
                <p class="money-saving" [innerHTML]="'minicheck.money.saving'| translate: placeholder"></p>
              </div>
            }
          </div>
        }
        @if (isPositiveSavingCo2 || isInputNeeded) {
          <div class="equivalents" [class.hide]="isNegativeSavingEur">
            <h3 [innerHTML]="'minicheck.equivalents.headline' | translate"></h3>
            @for (type of ['single-person', 'group', 'germany']; track type) {
              <div class="content">
                <i [class]="'icon-' + type"></i>
                @if (isPositiveSavingCo2 && !showUpdatedResult) {
                  <p class="text"
                     [innerHTML]="('minicheck.' + type + '.text' + (type === 'single-person' ? postfix : type === 'germany' ? postfixCoal : '')) | translate: placeholder"></p>
                }
                @if (isInputNeeded) {
                  <p class="text" [innerHTML]="'minicheck.input.needed.text' | translate"></p>
                }
                @if (showUpdatedResult) {
                  <p class="text" [innerHTML]="'minicheck.updating.result.text' | translate"></p>
                }
              </div>
            }
          </div>
        }
        @if (isNegativeSavingEur && !showUpdatedResult) {
          <div class="negative-savings hint">
            <h3 [innerHTML]="'minicheck.negative.savings.result.headline' | translate"></h3>
            <p [innerHTML]="'minicheck.negative.savings.text' | translate"></p>
          </div>
        }

        <section class="tipps">
          <strong [innerHTML]="'minicheck.tipps.headline' | translate"></strong>
          <p [innerHTML]="'minicheck.tipps.' + actionName + '.text' | translate"></p>
        </section>

        @if (isInternalPortal || forceDialog) {
          <app-dialogform [registrationData]="dialogData" textkeyPrefix="minicheck"
                          advisorImagePath="/mic/pdf-lead.svg" downloadUrl=""></app-dialogform>
        }

        @if (stcUrl && showStcTeaser) {
          <app-advisor-teaser [url]="stcUrl" [mailUrl]="stcUrl" textPrefix="minicheck.teaser.stc"
                              image="/mic/stc-teaser.svg"></app-advisor-teaser>
        }
        @if (tecUrl && showTecTeaser) {
          <app-advisor-teaser [url]="tecUrl" [mailUrl]="tecUrl" textPrefix="minicheck.teaser.tec"
                              image="/mic/tec-teaser.svg"></app-advisor-teaser>
        }
        @if (hecUrl && showHecTeaser) {
          <app-advisor-teaser [url]="hecUrl" [mailUrl]="hecUrl" textPrefix="minicheck.teaser.hec"
                              image="/mic/hec-teaser.svg"></app-advisor-teaser>
        }
        @if (wacUrl && showWacTeaser) {
          <app-advisor-teaser [url]="wacUrl" [mailUrl]="wacUrl" textPrefix="minicheck.teaser.wac"
                              image="/mic/wac-teaser.svg" changeColumnOrder="true"></app-advisor-teaser>
        }
        @if (mocUrl && showMocTeaser) {
          <app-advisor-teaser [url]="mocUrl" [mailUrl]="mocUrl" textPrefix="minicheck.teaser.moc"
                              image="/mic/moc-teaser.svg"></app-advisor-teaser>
        }

        <section class="portal">
          <app-portal-teaser></app-portal-teaser>
        </section>
      </div>
    </div>
  }
</div>



